// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as IndexRouteImport } from './routes/index'
import { Route as AboutRouteImport } from './routes/about'
import { Route as CartRouteImport } from './routes/cart'
import { Route as ChapterVialsRouteImport } from './routes/chapter-vials'
import { Route as DiscoverySetRouteImport } from './routes/discovery-set'
import { Route as FaqRouteImport } from './routes/faq'
import { Route as HowItWorksRouteImport } from './routes/how-it-works'
import { Route as CharacterArchiveIndexRouteImport } from './routes/character-archive.index'
import { Route as CharacterArchiveSlugRouteImport } from './routes/character-archive.$slug'
import { Route as FieldNotesIndexRouteImport } from './routes/field-notes.index'
import { Route as PagesContactRouteImport } from './routes/pages.contact'
import { Route as PagesFieldNotesRouteImport } from './routes/pages.field-notes'
import { Route as PagesNaturalPerfumeryRouteImport } from './routes/pages.natural-perfumery'
import { Route as PagesQuizRouteImport } from './routes/pages.quiz'
import { Route as ProductsIndexRouteImport } from './routes/products.index'
import { Route as ProductsSlugRouteImport } from './routes/products.$slug'
import { Route as ProductsDiscoverySetsRouteImport } from './routes/products.discovery-sets'
import { Route as BlogsBlogIndexRouteImport } from './routes/blogs.$blog.index'
import { Route as BlogsBlogArticleRouteImport } from './routes/blogs.$blog.$article'
import { Route as FieldNotesBlogIndexRouteImport } from './routes/field-notes.$blog.index'
import { Route as FieldNotesBlogArticleRouteImport } from './routes/field-notes.$blog.$article'

const IndexRoute = IndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => rootRouteImport
          })
const AboutRoute = AboutRouteImport.update({
            id: '/about',path: '/about',getParentRoute: () => rootRouteImport
          })
const CartRoute = CartRouteImport.update({
            id: '/cart',path: '/cart',getParentRoute: () => rootRouteImport
          })
const ChapterVialsRoute = ChapterVialsRouteImport.update({
            id: '/chapter-vials',path: '/chapter-vials',getParentRoute: () => rootRouteImport
          })
const DiscoverySetRoute = DiscoverySetRouteImport.update({
            id: '/discovery-set',path: '/discovery-set',getParentRoute: () => rootRouteImport
          })
const FaqRoute = FaqRouteImport.update({
            id: '/faq',path: '/faq',getParentRoute: () => rootRouteImport
          })
const HowItWorksRoute = HowItWorksRouteImport.update({
            id: '/how-it-works',path: '/how-it-works',getParentRoute: () => rootRouteImport
          })
const CharacterArchiveIndexRoute = CharacterArchiveIndexRouteImport.update({
            id: '/character-archive/',path: '/character-archive/',getParentRoute: () => rootRouteImport
          })
const CharacterArchiveSlugRoute = CharacterArchiveSlugRouteImport.update({
            id: '/character-archive/$slug',path: '/character-archive/$slug',getParentRoute: () => rootRouteImport
          })
const FieldNotesIndexRoute = FieldNotesIndexRouteImport.update({
            id: '/field-notes/',path: '/field-notes/',getParentRoute: () => rootRouteImport
          })
const PagesContactRoute = PagesContactRouteImport.update({
            id: '/pages/contact',path: '/pages/contact',getParentRoute: () => rootRouteImport
          })
const PagesFieldNotesRoute = PagesFieldNotesRouteImport.update({
            id: '/pages/field-notes',path: '/pages/field-notes',getParentRoute: () => rootRouteImport
          })
const PagesNaturalPerfumeryRoute = PagesNaturalPerfumeryRouteImport.update({
            id: '/pages/natural-perfumery',path: '/pages/natural-perfumery',getParentRoute: () => rootRouteImport
          })
const PagesQuizRoute = PagesQuizRouteImport.update({
            id: '/pages/quiz',path: '/pages/quiz',getParentRoute: () => rootRouteImport
          })
const ProductsIndexRoute = ProductsIndexRouteImport.update({
            id: '/products/',path: '/products/',getParentRoute: () => rootRouteImport
          })
const ProductsSlugRoute = ProductsSlugRouteImport.update({
            id: '/products/$slug',path: '/products/$slug',getParentRoute: () => rootRouteImport
          })
const ProductsDiscoverySetsRoute = ProductsDiscoverySetsRouteImport.update({
            id: '/products/discovery-sets',path: '/products/discovery-sets',getParentRoute: () => rootRouteImport
          })
const BlogsBlogIndexRoute = BlogsBlogIndexRouteImport.update({
            id: '/blogs/$blog/',path: '/blogs/$blog/',getParentRoute: () => rootRouteImport
          })
const BlogsBlogArticleRoute = BlogsBlogArticleRouteImport.update({
            id: '/blogs/$blog/$article',path: '/blogs/$blog/$article',getParentRoute: () => rootRouteImport
          })
const FieldNotesBlogIndexRoute = FieldNotesBlogIndexRouteImport.update({
            id: '/field-notes/$blog/',path: '/field-notes/$blog/',getParentRoute: () => rootRouteImport
          })
const FieldNotesBlogArticleRoute = FieldNotesBlogArticleRouteImport.update({
            id: '/field-notes/$blog/$article',path: '/field-notes/$blog/$article',getParentRoute: () => rootRouteImport
          })

const rootRouteChildren = {
  IndexRoute: IndexRoute,AboutRoute: AboutRoute,CartRoute: CartRoute,ChapterVialsRoute: ChapterVialsRoute,DiscoverySetRoute: DiscoverySetRoute,FaqRoute: FaqRoute,HowItWorksRoute: HowItWorksRoute,CharacterArchiveSlugRoute: CharacterArchiveSlugRoute,PagesContactRoute: PagesContactRoute,PagesFieldNotesRoute: PagesFieldNotesRoute,PagesNaturalPerfumeryRoute: PagesNaturalPerfumeryRoute,PagesQuizRoute: PagesQuizRoute,ProductsSlugRoute: ProductsSlugRoute,ProductsDiscoverySetsRoute: ProductsDiscoverySetsRoute,CharacterArchiveIndexRoute: CharacterArchiveIndexRoute,FieldNotesIndexRoute: FieldNotesIndexRoute,ProductsIndexRoute: ProductsIndexRoute,BlogsBlogArticleRoute: BlogsBlogArticleRoute,FieldNotesBlogArticleRoute: FieldNotesBlogArticleRoute,BlogsBlogIndexRoute: BlogsBlogIndexRoute,FieldNotesBlogIndexRoute: FieldNotesBlogIndexRoute
}
export const routeTree = rootRouteImport._addFileChildren(rootRouteChildren)